import { render } from "./Plan.vue?vue&type=template&id=89a2fc28&lang=pug"
import script from "./Plan.vue?vue&type=script&lang=js"
export * from "./Plan.vue?vue&type=script&lang=js"

import "./Plan.vue?vue&type=style&index=0&id=89a2fc28&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__